module.exports = __webpack_public_path__ + "img/fruit-kiwi-190x100.c58253bd.jpg";